import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemActionIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.88 10.69C20.6 10.05 19.98 9.64998 19.28 9.64998H14.53L15.17 1.91999C15.22 1.37999 14.92 0.889985 14.43 0.669985C13.93 0.449985 13.37 0.569985 13.01 0.969985L3.43 11.42C2.95 11.94 2.83 12.66 3.12 13.31C3.4 13.96 4.01999 14.36 4.72 14.36H9.47L8.81999 22.09C8.76999 22.63 9.07 23.12 9.56 23.34C10.05 23.56 10.61 23.44 10.98 23.04L20.56 12.59C21.04 12.07 21.16 11.35 20.87 10.7L20.88 10.69ZM19.46 11.57L10.38 21.48L11.03 13.67C11.07 13.25 10.71 12.85 10.28 12.86H4.72C4.48 12.83 4.39 12.64 4.54 12.44L13.62 2.51999L12.97 10.33C12.93 10.75 13.29 11.15 13.72 11.14H19.28C19.52 11.17 19.61 11.36 19.46 11.56V11.57Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemActionIcon.displayName = 'ItemActionIcon';
